import axios from "infra/http";
import { useQuery } from "react-query";

function useTenantPagamentoOnline(tenantId: string) {
  return useQuery(
    `/v1/tenants/${tenantId}/pagamento-online`,
    async () => {
      const { data } = await axios.get<{
        integradoPagamentoOnline: boolean;
      }>(`/v1/tenants/${tenantId}/pagamento-online`);

      return data;
    },
    {
      enabled: !!tenantId,
    }
  );
}

export default useTenantPagamentoOnline;
